import { useQuery } from "react-query";
import { fetchGroupedImagesData } from "./api";

export function useGroupedImages(filters, options={}) {
    return useQuery(["fetchGroupedImagesData", filters], () => fetchGroupedImagesData(filters), {
      staleTime: 0, 
      ...options
    })
  }